import { UNDEFINED } from '@utils';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringFilter' })
export class StringFilterPipe implements PipeTransform {
  transform(items: string[], field: string, q: string) {
    if (!q || q.trim().length === 0) {
      return items;
    }

    return items.filter(item => {
      if (typeof item[field] !== UNDEFINED) {
        return -1 < item[field].toLowerCase().indexOf(q.toLowerCase());
      }
    });
  }
}
